<template>
  <div class="padding-10">
    <toolbar v-model="date" @export="exportPDF" @input="init"></toolbar>
    <Details :date="date" :details="totals" ref="details"></Details>
    <technicians-list
      :date="date"
      :jobs="jobs"
      v-model="list"
      ref="techniciansList"
      :details="details"
    ></technicians-list>
  </div>
</template>

<script>
import Details from "../components/dispatchSheet/Details.vue";
import TechniciansList from "../components/dispatchSheet/TechniciansList.vue";
import Toolbar from "../components/dispatchSheet/Toolbar.vue";
import { customers, dispatch } from "../assets/js/firebase";
import {
  getStart,
  getEnd,
  formatDateOnly,
  getDateOnly,
} from "../assets/js/common";
import moment from "moment";
import { status } from "../assets/js/default";
import customerModal from "../assets/js/customer.modal";
export default {
  components: { Toolbar, Details, TechniciansList },
  data() {
    return {
      jobs: [],
      date: getDateOnly(),
      jobStatus: status,
      details: {},
      list: [],
    };
  },
  computed: {
    totals() {
      let total_cash = 0;
      let total_card_charge = 0;
      let on_account = 0;
      let approved_check = 0;
      let zelle_cash = 0;
      let total_reimbusements = 0;
      const vm = this;

      this.list.forEach((item) => {
        item.items.forEach((item) => {
          let {
            total,
            how_paid,
            charges,
            reimbusements,
            disposition,
            disposition_date,
          } = item;
          let isToday =
            formatDateOnly(disposition_date) == formatDateOnly(vm.date);
          if (disposition == customerModal.DISPOSITION_COMPLETE && isToday) {
            total = parseFloat(total);
            charges = parseFloat(charges);
            reimbusements = parseFloat(reimbusements);
            if (isNaN(total)) total = 0;
            if (isNaN(charges)) charges = 0;
            if (isNaN(reimbusements)) reimbusements = 0;
            if (how_paid == "Cash") {
              total_cash = parseFloat(total_cash) + parseFloat(total);
            }
            if (how_paid == "On Account") {
              on_account = parseFloat(on_account) + parseFloat(total);
            }
            if (how_paid == "Approved Check") {
              approved_check = parseFloat(approved_check) + parseFloat(total);
            }
            if (how_paid == "Zelle Cash") {
              zelle_cash = parseFloat(zelle_cash) + parseFloat(total);
            }
            if (how_paid == "Credit/Debit") {
              total_card_charge =
                parseFloat(total_card_charge) +
                (parseFloat(total) - parseFloat(charges));
            }
            total_reimbusements =
              parseFloat(total_reimbusements) + parseFloat(reimbusements);
          }
        });
      });
      let total_sale =
        total_cash +
        total_card_charge +
        on_account +
        approved_check +
        zelle_cash -
        total_reimbusements;
      return {
        total_cash: total_cash.toFixed(2),
        total_sale: total_sale.toFixed(2),
        total_card_charge: total_card_charge.toFixed(2),
        on_account: on_account.toFixed(2),
        approved_check: approved_check.toFixed(2),
        zelle_cash: zelle_cash.toFixed(2),
        total_reimbusements: total_reimbusements.toFixed(2),
      };
    },
  },
  methods: {
    reset() {
      this.details = {
        total_cash: "",
        total_sale: "",
        total_card_charge: "",
        on_account: "",
        approved_check: "",
        zelle_cash: "",
        total_reimbusements: "",
        technician_commission: {},
      };
      // this.$refs.details.init();
    },
    getDisposition({ disposition }) {
      let item = this.$store.getters.dispositions.find((item) => {
        return item.id == disposition;
      });
      return item instanceof Object ? item.name : "";
    },
    getNetSale(item) {
      let { total, charges, reimbusements } = item;
      total = parseFloat(total);
      charges = parseFloat(charges);
      reimbusements = parseFloat(reimbusements);
      if (isNaN(total)) total = 0;
      if (isNaN(charges)) charges = 0;
      if (isNaN(reimbusements)) reimbusements = 0;
      return (total - charges - reimbusements).toFixed(2);
    },
    getJobStatus({ status }) {
      let item = this.jobStatus.find((item) => {
        return item.value == status;
      });
      return item instanceof Object ? item.name : "";
    },
    exportPDF() {
      const vm = this;
      let technicians = vm.$refs.techniciansList.items;
      let date = moment(vm.date).format("MM/DD/YYYY");
      let weekday = moment(vm.date).format("dddd").toUpperCase();
      let { html } = require("../assets/print/dispatch.js");
      html = html.split("date").join(date);
      html = html.split("weekday").join(weekday);
      Object.keys(vm.totals).forEach((key) => {
        html = html.split(key).join(vm.totals[key]);
      });
      let technicians_table = "";
      for (let item of technicians) {
        let { table } = require("../assets/print/dispatch.js");
        table = table.split("name").join(item.technician_name);
        let { total_commission } = item;
        if (total_commission == undefined) total_commission = "";
        if (item.id) {
          let total_com =
            item.type == 3
              ? `Total  $${total_commission}`
              : `Total Commission $${total_commission}`;
          table = table.split("total_commission").join(total_com);
        } else {
          table = table.split("total_commission").join(``);
        }
        let cheapo_commission = item.type == 3 ? "Cheapo" : "Cheapo Commission";
        table = table.split("cheapo_commission").join(cheapo_commission);

        let cols = [
          "job_number",
          "tech_status",
          "invoice",
          "template_name",
          "status",
          "how_paid",
          "total",
          "technician_total_collected",
          "charges",
          "reimbusements",
          "net_sales",
          "technician_commission",
          "cheapo_commission",
          "disposition",
          "deposited",
        ];
        let table_body = "";
        item.items.forEach((job) => {
          let row = "<tr>";
          job.disposition = this.getDisposition(job);
          job.status = this.getJobStatus(job);
          job.net_sales = this.getNetSale(job);
          job.tech_status = this.getTechStatus(job);
          cols.forEach((key) => {
            let val = job[key];
            if (val == undefined) val = "";
            if (key == "reimbusements" && job.is_cheapo == true) {
              val = `${val} (Cheapo)`;
            }
            row = row + `<td>${val}</td>`;
          });
          row = row + "</tr>";
          table_body = table_body + row;
        });
        table = table.split("table_body").join(table_body);
        technicians_table = technicians_table + table;
      }
      html = html.split("technicians").join(technicians_table);
      let win = window.open("about:blank", "_blank");
      win.document.write(html);
      win.document.close();
      win.print();
    },
    async init(isFirst) {
      const vm = this;
      vm.reset();
      vm.jobs = [];
      vm.$loader.show();
      if (isFirst == true) {
        let { date } = vm.$route.query;
        if (!date) date = getDateOnly();
        vm.date = date;
      }
      try {
        let start = getStart(vm.date);
        let end = getEnd(vm.date);
        console.log(start);
        console.log(end);
        let jobs = await customers
          .orderBy("disposition_date", "desc")
          .where("disposition_date", ">=", start)
          .where("disposition_date", "<=", end)
          .where("status", "==", 7)
          .get();
        let sheet = await dispatch.doc(vm.date).get();
        if (sheet.exists) {
          vm.details = sheet.data();
        } else {
          await sheet.ref.set(vm.details);
        }
        if (getDateOnly() == vm.date) {
          let jobs2 = await customers.where("status", "!=", 7).get();
          jobs2.forEach((item) => {
            let doc = item.data();
            doc.id = item.id;
            vm.jobs.push(doc);
          });
        }
        jobs.forEach((item) => {
          let doc = item.data();
          doc.id = item.id;
          vm.jobs.push(doc);
        });
        vm.$loader.hide();
      } catch (error) {
        console.log(error);
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
  beforeMount() {
    this.init(true);
  },
};
</script>

<style></style>
